<template>
    <div id="app">
      <router-view></router-view>
    </div>
  </template>
  
  <script>
import {getDeviceType} from '../src/utils/index'
  export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data () {
      return {
        type:'',
      }
    },
    computed: {},
    watch: {},
    created () {},
    mounted () {
        this.type = getDeviceType()
        if(this.type != 'PC'){
            console.log('1')
        //手机端
        this.$router.replace("/mobile")
    }else{
        console.log('2')

        this.$router.replace("/pc")

    }
    },
    methods: {}
  }
  </script>